import React from 'react';
import {ErrorComponent, Button} from '@ab/components';

export default function template() {
    let {error, info} = this.state;

    return (
        <div className="module-app">
            <ErrorComponent type="global">{error.message}</ErrorComponent>
            <div>{info.componentStack}</div>
            <br />
            <div className="text-center">
                <Button onClick={e => window.location.reload()}>{this.l10n('Обновить')}</Button>
            </div>
        </div>
    );
}
